<template>
  <div space-y-6 pb-6>
    <div relative v-if="userLocation">
      <Map
        bg-stone-100
        bg-opacity-50
        :options="options"
        @load="loadMap"
        :sources="sources"
        :layers="layers"
        :marker="true"
        v-bind="$attrs"
      />
      <Toggle class="my-2 sm:(absolute bottom-0 left-0 m-2)" color="blue" v-model="selected" :options="layerOptions" />
      <Legend class="my-2 sm:(absolute bottom-0 top-20 overflow-scroll right-0 m-2)" :options="USDA_ZONES" />
    </div>
    <div pt-6>
      <p>
        Official 2023 and 2012 USDA Plant Hardiness Zone Maps provided by the US Department of Agriculture and Oregon
        State University
      </p>
      <div flex gap-4 justify-center justify-around flex-wrap>
        <img src="/img/osu-logo.svg" width="239" height="77" alt="Oregon State University" class="max-h-[60px]" />
        <img src="/img/ars-color-lockup.svg" width="300" height="37" alt="USDA Agricultural Research Service" />
      </div>
    </div>
  </div>
</template>
<script setup>
import { point } from "@turf/turf";
const props = defineProps({
  location: {
    type: Object,
    required: true,
  },
});
let map;

const layerOptions = [
  {
    value: "zones-2023",
    label: "2023 Zones",
  },
  {
    value: "zones-2012",
    label: "2012 Zones",
  },
];
const selected = ref("zones-2023");

const userLocation = computed(() => {
  if (isNumber(props.location?.latitude) && isNumber(props.location?.longitude)) {
    return point([props.location.longitude, props.location.latitude], {
      type: "userLocation",
    });
  }
  return null;
});

const sources = computed(() => [
  {
    id: "zones",
    type: "vector",
    url: "pmtiles://https://tiles.whatismyelevation.com/zones.pmtiles",
    maxzoom: 6,
  },
]);
const options = computed(() => {
  return {
    center: userLocation.value.geometry.coordinates,
    zoom: 9,
    style: "/styles/elevation-color.json",
  };
});
const zoneLookup = (() => {
  const lookup = [];
  USDA_ZONES.forEach((zone, index) => {
    lookup.push(index + 1);
    lookup.push(zone.color);
  });
  return lookup;
})();
const zoneLookup2023 = (() => {
  const lookup = [];
  USDA_ZONES.forEach((zone, index) => {
    lookup.push(zone.name.toLowerCase());
    lookup.push(zone.color);
  });
  return lookup;
})();
const layers = computed(() => [
  {
    id: "zones-2012",
    beforeId: "boundary_3",
    type: "fill",
    source: "zones",
    "source-layer": "zones_2012",
    paint: {
      "fill-color": ["match", ["get", "GRIDCODE"], ...zoneLookup, "#ffffff"],
      "fill-opacity": selected.value === "zones-2012" ? 0.8 : 0,
    },
  },
  {
    id: "zones-2023",
    beforeId: "boundary_3",
    type: "fill",
    source: "zones",
    "source-layer": "zones_2023",
    paint: {
      "fill-color": ["match", ["get", "zone"], ...zoneLookup2023, "#ffffff"],
      "fill-opacity": selected.value === "zones-2023" ? 0.8 : 0,
    },
  },
]);

function loadMap(mapValue) {
  map = mapValue;
}
</script>
